module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('div', {
    attrs: {
      "id": "titleArea"
    }
  }, [_c('div', {
    staticClass: "titleText"
  }, [_vm._v("学分认定")]), _vm._v(" "), _c('div', {
    staticClass: "titleButton"
  }, [_c('el-button', {
    staticClass: "custom-el-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showHomePage
    }
  }, [_c('i', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" 首页\n                ")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "queryArea"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "formItem"
  }, [(_vm.teaAuthVisible) ? _c('el-input', {
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stuAuthVisible) ? _c('el-input', {
    attrs: {
      "placeholder": "原 / 现课程名称",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.courseName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "courseName", $$v)
      },
      expression: "queryForm.courseName"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "formItem text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  }), _vm._v(" 更多")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 申请")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "queryDialog",
      "title": "查询信息",
      "width": "90%",
      "visible": _vm.queryDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.queryDialogVisible = $event
      }
    }
  }, [(_vm.teaAuthVisible) ? _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "原 / 现课程名称",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.courseName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "courseName", $$v)
      },
      expression: "queryForm.courseName"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "placeholder": "审核状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.comboOption.auditState), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_vm._v("查 询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重 置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listArea"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.tableData == null || _vm.tableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有申请记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学       号：")]), _vm._v(_vm._s(item.stuCode))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("姓       名：")]), _vm._v(_vm._s(item.stuName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("课程代码：")]), _vm._v(_vm._s(item.oriCourseCode))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("课程名称：")]), _vm._v(_vm._s(item.oriCourseName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("课程类型：")]), _vm._v(_vm._s(item.oriCourseTypeName))]), _vm._v(" "), _c('div', {
      staticClass: "auditStateImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadStateImg(item),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.modRec(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.submitRec(item)
        }
      }
    }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.delRec(item)
        }
      }
    }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' && item.auditAuth == '0') ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showDetailInfo(item)
        }
      }
    }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), (item.auditAuth == '1') ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.auditRec(item)
        }
      }
    }, [_vm._v("审核")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' || item.auditState != '') ? _c('el-button', {
      on: {
        "click": function($event) {
          return _vm.showAuditList(item)
        }
      }
    }, [_vm._v("审核信息")]) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.tableData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍候...\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    ref: "applyForm",
    attrs: {
      "model": _vm.applyForm,
      "label-width": "84px",
      "label-position": "left",
      "width": "100%",
      "rules": _vm.curdRules
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "编号",
      "prop": "id"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.applyForm.id),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "id", $$v)
      },
      expression: "applyForm.id"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.teaAuthVisible && _vm.fieldVisible),
      expression: "teaAuthVisible && fieldVisible"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生",
      "prop": "stuInfo"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchStu,
      "placeholder": "可输入学号或姓名搜索学生",
      "trigger-on-focus": false,
      "clearable": ""
    },
    on: {
      "clear": _vm.clearSelectStu
    },
    model: {
      value: (_vm.stuInfo),
      callback: function($$v) {
        _vm.stuInfo = $$v
      },
      expression: "stuInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stuAuthVisible || !_vm.fieldVisible),
      expression: "stuAuthVisible || !fieldVisible"
    }],
    attrs: {
      "label": "学生",
      "prop": "stuCode"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.stuCode + ' - ' + _vm.applyForm.stuName) + "\n                        "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    model: {
      value: (_vm.applyForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "stuCode", $$v)
      },
      expression: "applyForm.stuCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    attrs: {
      "label": "原课程",
      "prop": "oriPlanCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择原课程"
    },
    on: {
      "change": _vm.selectOriCourse
    },
    model: {
      value: (_vm.applyForm.oriPlanCode),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "oriPlanCode", $$v)
      },
      expression: "applyForm.oriPlanCode"
    }
  }, _vm._l((_vm.comboOption.oriCourseInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "原课程名称",
      "prop": "oriCourseName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.oriCourseName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原课程代码",
      "prop": "oriCourseCode"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.oriCourseCode) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原课程类型",
      "prop": "oriCourseTypeName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.oriCourseTypeName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原学分",
      "prop": "oriCredit"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.oriCredit) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原成绩",
      "prop": "oriScore"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.oriScore) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    attrs: {
      "label": "现课程",
      "prop": "newPlanCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择现课程"
    },
    on: {
      "change": _vm.selectNewCourse
    },
    model: {
      value: (_vm.applyForm.newPlanCode),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "newPlanCode", $$v)
      },
      expression: "applyForm.newPlanCode"
    }
  }, _vm._l((_vm.comboOption.newCourseInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "现课程名称",
      "prop": "newCourseName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.newCourseName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现课程代码",
      "prop": "newCourseCode"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.newCourseCode) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现课程代码",
      "prop": "newCourseTypeName"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.newCourseTypeName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现学分",
      "prop": "newCredit"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.newCredit) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    attrs: {
      "label": "申请说明",
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写申请说明",
      "autoComplete": "on",
      "type": "textarea",
      "rows": 5,
      "show-word-limit": "",
      "maxlength": "500"
    },
    model: {
      value: (_vm.applyForm.desc),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "desc", $$v)
      },
      expression: "applyForm.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "申请说明",
      "prop": "desc"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.applyForm.desc) + "\n                    ")])], 1)], 1), _vm._v(" "), (_vm.auditAreaVisible) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('audit', {
    ref: "audit",
    attrs: {
      "itemCode": _vm.auditParam,
      "relatedCode": _vm.selectRowData.id,
      "auditLevel": _vm.selectRowData.auditLevel
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fieldVisible) ? _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.saveRec
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "success",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.saveAndSubmitRec
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.selectRowData.id,
      "listHeight": 450
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-493f1c2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/creditIdentified.vue
// module id = 1822
// module chunks = 502